module.exports = __webpack_public_path__ + "media/images/suceess-story4-e0604395bf17998e2ade458c3cb7e8ab.jpg";